export default "__VITE_ASSET__DSWEZOaI__"